import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/national-parks/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("national-parks", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Puistoa ei löytynyt — what Finland" }, { name: "robots", content: "noindex" }] };
    }
    const place = (loaderData as any).place;
    const path = `/fi/national-parks/${params.slug}`;
    const url = `https://whatfinland.com${path}`;
    const title = `${place.name} — kävijän opas | what Finland`;
    const desc = (place.description ?? "").slice(0, 155) || `Suunnittele vierailu kohteeseen ${place.name}.`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
        { name: "twitter:card", content: "summary_large_image" },
        ...(place.image_url?.startsWith("https://")
          ? [
              { property: "og:image", content: place.image_url },
              { name: "twitter:image", content: place.image_url },
            ]
          : []),
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflangLinks(path)],
    };
  },
  component: FiNationalParkPage,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Puistoa ei löytynyt</h1>
        <Link to="/fi/national-parks" className="mt-6 inline-block text-royal underline">
          Selaa kansallispuistoja
        </Link>
      </div>
    </div>
  ),
});

function FiNationalParkPage() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="national-parks" placeSlug={slug} locale="fi" />;
}
